import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  EVENT_INPUT_DEFAULT_OPTION,
  EVENTS_NOT_FOUND,
  REPORT_GENERATION_FAILED,
} from "../../types";
import { getEventsRequest } from "../../actions";
import Loading from "../../components/Loading";
import "../../assets/styles//events/EventReports.css";
import { requests, downloadReport } from "../../axios";
import { useFormik } from "formik";

const EventReports = (props) => {
  const [requestState, setRequestState] = useState({
    loading: true,
    error: null,
  });

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  const fetchData = async () => {
    try {
      if (!props.events.length) {
        const response = await requests.events.getAllEvents();
        props.getEventsRequest(response.data);
      }
      setRequestState({ ...requestState, loading: false });
    } catch (error) {
      console.log(error.response.status);
      setRequestState({
        loading: false,
        error: EVENTS_NOT_FOUND,
      });
    }
  };

  const formik = useFormik({
    initialValues: {
      eventId: "",
    },
    onSubmit: async (values) => {
      setRequestState({ loading: true, error: null });
      try {
        const responsePDF = await requests.reports.getEventAssistanceReport(
          values.eventId
        );
        downloadReport(responsePDF.data, "Registro de Asistencia", "pdf");
        const responseXLSX = await requests.reports.getEventAssistanceReport(
          values.eventId, true
        );
        downloadReport(responseXLSX.data, "Registro de Asistencia", "xlsx");
        setRequestState({ ...requestState, loading: false });
      } catch (error) {
        console.log(error.response.status);
        setRequestState({ loading: false, error: REPORT_GENERATION_FAILED });
      }
    },
  });

  const options =
    props.events.length &&
    props.events.map((event, index) => {
      return (
        <option value={event.eventId} key={index}>
          {event.name}
        </option>
      );
    });

  const handleOnChange = async () => {
    const eventId = document.getElementById("event").value;
    formik.setFieldValue("eventId", eventId);
  };

  return (
    <>
      {requestState.loading ? (
        <Loading />
      ) : (
        <>
          <section className="userform" role="form">
            <form
              className="square-form event-reporter-grid"
              onSubmit={formik.handleSubmit}
            >
              <h2 className="event-reporter-title">Generar Reportes</h2>
              <h5 className="event-label">Evento</h5>
              <select
                className="userform-select event-form-select"
                id="event"
                name="event"
                data-testid="eventInput"
                value={formik.values.eventId}
                onChange={handleOnChange}
                required
              >
                <option value="">{EVENT_INPUT_DEFAULT_OPTION}</option>
                {options}
              </select>
              {requestState.error && (
                <h6 className="bad-request error-message" role="alert">
                  {requestState.error}
                </h6>
              )}
              <input
                type="submit"
                className="btn-block btn scaf-accept-btn"
                value="Generar"
              />
            </form>
          </section>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    events: state.events,
  };
};

const mapDispatchToProps = {
  getEventsRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(EventReports);
